import { render } from "./customer_profile.html?vue&type=template&id=b7046288&external"
import script from "./customer_profile.js?vue&type=script&lang=js&external"
export * from "./customer_profile.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__